export const API_PATH = process.env.REACT_APP_API_PATH